module.exports = __webpack_public_path__ + "static/media/satsang.2907e5b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/satsang.jpg
// module id = 127
// module chunks = 0